export const POST = "POST"
export const PUT = "PUT"
export const GET = "GET"